import { object, string } from 'yup';
import '@client/yup';

export const MessageSchema = object().shape({
  message: string().label('Message').trim().max(10000)
    .required(),
});
